import type { PaymentsMessageId } from "./payments.fr";

/** Paiements in Dutch. Same keys and {placeholders} as payments.fr.ts. */
export const paymentsNl: Record<PaymentsMessageId, string> = {
  "payments.tab.payments": "Betalingen",
  "payments.tab.approvals": "Goedkeuringsverzoeken",
  "payments.pick": "Kies een betaling in de lijst.",
  "payments.loading": "Betaling laden…",
  "payments.loadFailed": "Deze betaling kon niet worden geladen.",
  "payments.notFound": "Deze betaling is niet gevonden. Laad de lijst opnieuw.",
  "payments.refreshFailed": "De betaling kon niet worden vernieuwd: ze wordt getoond zoals ze was.",

  "payments.filter.provider": "Betaalmiddel",
  "payments.filter.status": "Status",
  "payments.filter.all": "Alle",
  "payments.filter.from": "Van",
  "payments.filter.to": "Tot",
  "payments.filter.duplicates": "Waarschijnlijk dubbel",
  "payments.filter.clearPro": "Alle pro's",
  "payments.list.loading": "Betalingen laden…",
  "payments.list.loadFailed": "De betalingen konden niet worden geladen.",
  "payments.list.empty": "Geen betalingen voor deze filters.",
  "payments.list.aria": "Betalingen van kosten",
  "payments.list.end": "Einde van de lijst",
  "payments.pill.duplicate": "Waarschijnlijk dubbel",

  "payments.status.pending": "Te betalen",
  "payments.status.paid": "Betaald",
  "payments.status.failed": "Mislukt",
  "payments.status.refunded": "Terugbetaald",
  "payments.status.waived": "Kosten kwijtgescholden",
  "payments.provider.orange_money": "Orange Money",
  "payments.provider.lengo_pay": "Mobile Money",
  "payments.provider.stripe": "Kaart (Stripe)",
  "payments.provider.wave": "Wave",
  "payments.feeType.per_job": "Kosten per contactlegging",
  "payments.feeType.monthly": "Maandabonnement",
  "payments.feeType.yearly": "Jaarabonnement",
  "payments.kind.refund": "Terugbetaling",
  "payments.kind.credit": "Tegoed",
  "payments.kind.waive": "Kwijtschelding van kosten",
  "payments.kind.mark_paid": "Als betaald gemarkeerd",

  "payments.detail.versionTitle": "De getoonde versie van de betaling: elke correctie stuurt die mee.",
  "payments.detail.duplicate": "Waarschijnlijk dubbel",
  "payments.detail.duplicateBody":
    "Een andere betaling van dezelfde pro, met hetzelfde bedrag, enkele minuten eerder of later. Controleer voordat u terugbetaalt:",
  "payments.detail.pro": "De pro",
  "payments.detail.proPayments": "Betalingen van deze pro →",
  "payments.detail.transaction": "Referentie bij de aanbieder",
  "payments.detail.job": "Aanvraag",
  "payments.detail.refunded": "Al terugbetaald",
  "payments.detail.refundable": "Nog terug te betalen",
  "payments.detail.credit": "Tegoed van de pro",
  "payments.detail.adjustments": "Correcties",
  "payments.detail.noAdjustments": "Geen correcties op deze betaling.",
  "payments.detail.actions": "Corrigeren",
  "payments.detail.neverOptimistic":
    "Niets wordt als gedaan getoond vóór het antwoord van de server. Een terugbetaling zonder antwoord van de aanbieder wordt nooit opnieuw verzonden.",
  "payments.col.kind": "Correctie",
  "payments.col.amount": "Bedrag",
  "payments.col.status": "Stand",
  "payments.col.by": "Door",
  "payments.col.actions": "Acties",

  "payments.adjustment.status.pending": "Status onbekend, wordt gecontroleerd",
  "payments.adjustment.status.done": "Gedaan",
  "payments.adjustment.status.failed": "Geweigerd door de aanbieder",
  "payments.adjustment.status.awaiting_manual_transfer": "Handmatige overschrijving nodig",
  "payments.adjustment.status.awaiting_approval": "Wacht op goedkeuring",
  "payments.adjustment.status.rejected": "Geweigerd door de eigenaar",
  "payments.adjustment.outcomeUnknownHint":
    "Naar de aanbieder verzonden, zonder antwoord. Het wordt nooit opnieuw verzonden: controleer het op diens dashboard en wikkel het dan af.",
  "payments.adjustment.manualHint":
    "Orange Money heeft geen automatische terugbetaling: stuur het geld handmatig en wikkel het dan af met de referentie van de overschrijving.",

  "payments.action.refund": "Terugbetalen",
  "payments.action.credit": "Tegoed geven",
  "payments.action.waive": "Kosten kwijtschelden",
  "payments.action.markPaid": "Als betaald markeren",
  "payments.action.settle": "Afwikkelen",
  "payments.action.approve": "Goedkeuren",
  "payments.action.reject": "Weigeren",

  "payments.dialog.refund.title": "Terugbetalen · {subject}",
  "payments.dialog.refund.body":
    "De terugbetaling wordt vastgelegd en daarna één keer naar de aanbieder verzonden. Boven het plafond wacht ze op goedkeuring van een eigenaar.",
  "payments.dialog.credit.title": "Tegoed geven · {subject}",
  "payments.dialog.credit.body":
    "Een saldo dat van de volgende kosten van de pro wordt afgetrokken, in dezelfde valuta.",
  "payments.dialog.waive.title": "Kosten kwijtschelden · {subject}",
  "payments.dialog.waive.body":
    "De kosten zijn niet meer verschuldigd. Boven het plafond wacht de kwijtschelding op goedkeuring van een eigenaar.",
  "payments.dialog.markPaid.title": "Als betaald markeren · {subject}",
  "payments.dialog.markPaid.body":
    "Alleen met de referentie van de echte betaling (de sms van de pro of het afschrift). Eén referentie markeert maar één betaling.",
  "payments.dialog.settle.title": "Terugbetaling afwikkelen · {subject}",
  "payments.dialog.settle.body":
    "Noteer hoe de terugbetaling is afgelopen, nadat u het bij de aanbieder hebt gecontroleerd.",
  "payments.dialog.approve.title": "Verzoek van {subject} goedkeuren",
  "payments.dialog.approve.body": "De gevraagde correctie geldt vanaf nu. Niemand keurt een eigen verzoek goed.",
  "payments.dialog.reject.title": "Verzoek van {subject} weigeren",
  "payments.dialog.reject.body":
    "Er wordt niets terugbetaald of kwijtgescholden. De reden wordt bij het verzoek bewaard.",
  "payments.field.amount": "Bedrag ({currency})",
  "payments.field.refundHint": "Laat leeg om alles terug te betalen: {amount}.",
  "payments.field.orangeMoneyReference": "Referentie van de Orange Money-transactie",
  "payments.field.reference": "Referentie bij de aanbieder",
  "payments.field.referenceHint": "Kopieer ze volledig uit de sms of het afschrift: letters, cijfers en . _ : / -",
  "payments.field.outcome": "Resultaat",
  "payments.field.outcome.done": "Het geld is verzonden",
  "payments.field.outcome.failed": "De terugbetaling is mislukt",

  "payments.problem.reason": "Geef een reden van minstens {min} tekens.",
  "payments.problem.amount": "Voer een bedrag groter dan nul in, met hoogstens twee decimalen.",
  "payments.problem.tooMuch": "Dat is meer dan er nog terug te betalen is.",
  "payments.problem.reference":
    "Kopieer de referentie volledig: minstens {min} tekens, alleen letters, cijfers en . _ : / -.",

  "payments.outcome.done": "{kind} van {amount}: gedaan.",
  "payments.outcome.pending":
    "{kind} van {amount}: status onbekend, wordt gecontroleerd. Het wordt niet opnieuw verzonden; wikkel het af zodra het is gecontroleerd.",
  "payments.outcome.awaiting_manual_transfer":
    "{kind} van {amount} vastgelegd: stuur het geld handmatig en wikkel het dan af met de referentie.",
  "payments.outcome.awaiting_approval": "{kind} van {amount}: meer dan je alleen mag doen, wacht op goedkeuring.",
  "payments.outcome.failed": "{kind} van {amount} geweigerd door de aanbieder ({failure}). Er is niets veranderd.",
  "payments.outcome.rejected": "{kind} van {amount} geweigerd.",

  "payments.approvals.status.pending": "In afwachting",
  "payments.approvals.status.approved": "Goedgekeurd",
  "payments.approvals.status.rejected": "Geweigerd",
  "payments.approvals.loading": "Verzoeken laden…",
  "payments.approvals.loadFailed": "De goedkeuringsverzoeken konden niet worden geladen.",
  "payments.approvals.empty": "Hier zijn geen verzoeken.",
  "payments.approvals.requested": "Gevraagd door {name} op {date}",
  "payments.approvals.permission": "Machtiging: {permission}",
  "payments.approvals.theirLimit": "Hun limiet: {amount}",
  "payments.approvals.noPermission": "Deze persoon heeft deze machtiging niet.",
  "payments.approvals.noLimitInCurrency": "Deze persoon heeft geen limiet in deze valuta.",
  "payments.approvals.openPro": "De pro openen →",
  "payments.approvals.decided": "Beslist door {name} op {date}",
  "payments.approvals.openPayment": "Betaling openen →",
  "payments.approvals.own": "Dit is uw verzoek: een andere eigenaar moet erover beslissen.",

  "payments.export.month": "Te exporteren maand",
  "payments.export.reason": "Reden (optioneel)",
  "payments.export.button": "CSV exporteren",
  "payments.export.running": "Exporteren…",
  "payments.export.hint":
    "De betalingen van de maand (UTC) voor de afstemming, zonder telefoon of e-mail. Elke export wordt vastgelegd in het auditlogboek.",
  "payments.export.done": "Export gedownload. Die is vastgelegd in het auditlogboek.",

  "payments.error.stale":
    "Deze betaling is gewijzigd terwijl u ernaar keek. Laad ze opnieuw, controleer en probeer het dan nog eens.",
  "payments.error.refused":
    "Correctie geweigerd: uw rollen bevatten niet de benodigde functie. Vraag een leidinggevende om toegang.",
  "payments.error.approvalRefused":
    "Geweigerd: alleen een eigenaar met APPROVE_PAYMENT_REQUESTS kan beslissen, en nooit over een eigen verzoek.",
  "payments.error.invalid":
    "Geweigerd: de betaling is niet meer in de verwachte staat, het bedrag is hoger dan wat overblijft, of de referentie is al gebruikt. Laad opnieuw en controleer.",
  "payments.error.outcomeUnknown":
    "Geen antwoord van de server: de correctie is misschien vastgelegd. Probeer het opnieuw: dezelfde klik kan niet twee keer worden toegepast.",

  "payments.refused.notRefundable":
    "Geweigerd: alleen betaalde kosten kunnen worden terugbetaald. Laad de betaling opnieuw.",
  "payments.refused.nothingToRefund":
    "Geweigerd: deze kosten zijn al volledig terugbetaald, of de rest staat nog open. Laad de betaling opnieuw.",
  "payments.refused.refundTooLarge":
    "Geweigerd: het bedrag is hoger dan wat er van deze kosten nog terug te betalen is.",
  "payments.refused.alreadyAwaitingApproval":
    "Geweigerd: een kwijtschelding van deze kosten wacht al op een eigenaar. Laad de betaling opnieuw.",
  "payments.refused.notMarkable":
    "Geweigerd: alleen openstaande of mislukte kosten kunnen als betaald worden gemarkeerd. Laad de betaling opnieuw.",
  "payments.refused.referenceInUse":
    "Geweigerd: met deze Orange Money-referentie zijn al andere kosten betaald. Controleer de referentie.",
  "payments.refused.referenceRequired": "Vul de transactiereferentie in.",
  "payments.refused.alreadySettled": "Deze terugbetaling is net afgehandeld. Laad haar opnieuw.",
  "payments.refused.alreadyDecided": "Over dit verzoek is net beslist. Laad de lijst opnieuw.",
  "payments.refused.ownRequest": "Geweigerd: u deed dit verzoek, dus een andere eigenaar beslist.",
  "payments.refused.approverNotPermitted":
    "Je hebt deze machtiging niet voor dit bedrag, dus je kunt niet beslissen. Iemand anders beslist.",
  "payments.refused.paymentChanged":
    "Geweigerd: de betaling is sinds het verzoek gewijzigd. Wijs het verzoek af, met de reden.",
  "payments.refused.currencyMismatch": "Geweigerd: het tegoed moet in de valuta van de kosten zijn.",
  "payments.refused.feeOfAnotherPro": "Geweigerd: deze kosten zijn door een andere pro betaald.",
  "payments.refused.invalidAmount": "Geweigerd: het bedrag moet hoger zijn dan nul.",
};
